export const contentsConstants = {
  RESULTS_BY_SEARCH: 10, //It should match with v1/article-search API view on Backend.
  RESULTS_BY_CATEGORY: 2, //It should match with v1/article-featured API view on Backend.
  RESULTS_BY_MYCONTENT: 3, //It should match with v1/my-content API view on Backend.
};
